import React from "react";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";

import "./styles.css";

/** Atalho de retorno para a Home, usado nas paginas da aba "Menu". */
const MenuPageBackLink = () => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="menu-page-back"
      onClick={() => navigate("/app")}
    >
      <ArrowBackRoundedIcon aria-hidden="true" />
      <span>Voltar</span>
    </button>
  );
};

export default MenuPageBackLink;
